import api from './api';

const salesContinuousServiceService = {
  getContinuousServices: async (params = {}) => {
    try {
      const response = await api.get('/ventas/continuous-services', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener servicios continuos de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener servicios continuos',
        data: [],
      };
    }
  },

  getContinuousService: async (id) => {
    try {
      const response = await api.get(`/ventas/continuous-services/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener servicio continuo de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener servicio continuo',
      };
    }
  },

  createContinuousService: async (data) => {
    try {
      const response = await api.post('/ventas/continuous-services', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear servicio continuo de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear servicio continuo',
        errors: error.response?.data?.errors || {},
      };
    }
  },

  updateContinuousService: async (id, data) => {
    try {
      const response = await api.put(`/ventas/continuous-services/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar servicio continuo de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar servicio continuo',
      };
    }
  },

  closeContinuousService: async (id, data = {}) => {
    try {
      const response = await api.patch(`/ventas/continuous-services/${id}/close`, data);
      return response.data;
    } catch (error) {
      console.error('Error al cerrar servicio continuo de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al cerrar servicio continuo',
      };
    }
  },

  openContinuousService: async (id) => {
    try {
      const response = await api.patch(`/ventas/continuous-services/${id}/open`);
      return response.data;
    } catch (error) {
      console.error('Error al abrir servicio continuo de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al abrir servicio continuo',
      };
    }
  },

  createProgress: async (id, data) => {
    try {
      const response = await api.post(`/ventas/continuous-services/${id}/progress`, data);
      return response.data;
    } catch (error) {
      console.error('Error al crear avance de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear registro de avance',
        errors: error.response?.data?.errors || {},
      };
    }
  },

  updateProgress: async (id, progressId, data) => {
    try {
      const response = await api.put(`/ventas/continuous-services/${id}/progress/${progressId}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar avance de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar registro de avance',
        errors: error.response?.data?.errors || {},
      };
    }
  },

  deleteProgress: async (id, progressId) => {
    try {
      const response = await api.delete(`/ventas/continuous-services/${id}/progress/${progressId}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar avance de ventas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar registro de avance',
      };
    }
  },
};

export default salesContinuousServiceService;
